import { hasOnlyMerchandiseItems, isMerchandiseItem } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'
import { createSelector } from 'reselect'

const getMerchandiseItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items) => items.filter(isMerchandiseItem),
  reselectShallowEqual,
)

export const getCartHasOnlyMerchandiseItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  hasOnlyMerchandiseItems,
)

export default getMerchandiseItems
